module.exports = __webpack_public_path__ + "img/development-during-recession-top.9a48ed8f.webp";